/* eslint-disable jsx-a11y/label-has-associated-control */
import { Form } from 'semantic-ui-react';
import { useState } from '@wordpress/element';
import BarChart from '../BarChart';
import data from '../../data.json';

const RacialInequalityContainer = () => {
    const [changes, setChanges] = useState('Will not make the changes needed');
    const [supportBLM, setSupportBLM] = useState('Strongly/Somewhat support');

    return (
        <>
            <div className="content-box">
                <h3 id="racial-inequality">Racial inequality</h3>
                <section id="give-equal-rights">
                    <p>
                        Solid majorities of blacks across all demographic groups
                        say the country needs to continue making changes to give
                        blacks equal rights with whites. While whites have moved
                        closer to this position in recent years, the share that
                        agrees remains significantly smaller (88% of blacks vs.
                        53% of whites).
                    </p>
                    <div className="chart-container">
                        <h4 className="chart-title">
                            Our country ______ to give blacks equal rights with
                            whites
                        </h4>
                        <div className="radio-container">
                            {/* <Form.Group inline> */}
                            <Form.Radio
                                label="Will eventually make the changes needed"
                                checked={
                                    'Will eventually make the changes needed' ===
                                    changes
                                }
                                value="Will eventually make the changes needed"
                                onClick={() =>
                                    setChanges(
                                        'Will eventually make the changes needed',
                                    )
                                }
                            />
                            <Form.Radio
                                label="Will not make the changes needed"
                                checked={
                                    'Will not make the changes needed' ===
                                    changes
                                }
                                value="Will not make the changes needed"
                                onClick={() =>
                                    setChanges(
                                        'Will not make the changes needed',
                                    )
                                }
                            />
                            <Form.Radio
                                label="Has already made the changes needed"
                                checked={
                                    'Has already made the changes needed' ===
                                    changes
                                }
                                value="Has already made the changes needed"
                                onClick={() =>
                                    setChanges(
                                        'Has already made the changes needed',
                                    )
                                }
                            />
                            {/* </Form.Group> */}
                        </div>
                        {'Will eventually make the changes needed' ===
                            changes && <BarChart data={data.willMakeChanges} />}
                        {'Will not make the changes needed' === changes && (
                            <BarChart data={data.wontMakeChanges} />
                        )}
                        {'Has already made the changes needed' === changes && (
                            <BarChart data={data.hasMadeChanges} />
                        )}
                    </div>
                </section>
                <section id="support-blm">
                    <p>
                        About two-thirds of blacks say they strongly (41%) or
                        somewhat (24%) support the Black Lives Matter movement.
                        Four-in-ten whites say they at least somewhat support
                        it. There are large racial gaps in opinions across
                        gender, age and education level, but roughly two-thirds
                        of both white and black Democrats support Black Lives
                        Matter. Just two-in-ten white Republicans express
                        support.
                    </p>
                    <div className="chart-container">
                        <h4 className="chart-title">
                            Percent saying they ______ the Black Lives Matter
                            movement
                        </h4>
                        <div className="radio-container">
                            <Form.Radio
                                label="Strongly/Somewhat support"
                                checked={
                                    'Strongly/Somewhat support' === supportBLM
                                }
                                value="Strongly/Somewhat support"
                                onClick={() =>
                                    setSupportBLM('Strongly/Somewhat support')
                                }
                            />
                            <Form.Radio
                                label="Strongly/Somewhat oppose"
                                checked={
                                    'Strongly/Somewhat oppose' === supportBLM
                                }
                                value="Strongly/Somewhat oppose"
                                onClick={() =>
                                    setSupportBLM('Strongly/Somewhat oppose')
                                }
                            />
                            <Form.Radio
                                label="Haven't heard of"
                                checked={'Haven"t heard of' === supportBLM}
                                value="Haven't heard of"
                                onClick={() =>
                                    setSupportBLM('Haven"t heard of')
                                }
                            />
                        </div>

                        {'Strongly/Somewhat support' === supportBLM && (
                            <BarChart data={data.supportBLM} />
                        )}
                        {'Strongly/Somewhat oppose' === supportBLM && (
                            <BarChart data={data.opposeBLM} />
                        )}
                        {'Haven"t heard of' === supportBLM && (
                            <BarChart data={data.haventHeardOf} />
                        )}
                    </div>
                </section>
            </div>
        </>
    );
};

export default RacialInequalityContainer;
